import React, { useRef, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { uploadCSV } from "../../../../assets";

interface CSVUploaderProps {
  onFileUpload: (file: File) => void;
  onFileRemove: () => void;
  setSelectedFile: React.Dispatch<React.SetStateAction<File | null>>;
  selectedFile: File | null;
}

const CSVUploader: React.FC<CSVUploaderProps> = ({
  onFileUpload,
  onFileRemove,
  setSelectedFile,
  selectedFile,
}) => {
  const [error, setError] = useState<string | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) {
      setError("No file selected.");
      return;
    }

    if (file.type !== "text/csv") {
      setError("Only CSV files are allowed.");
      return;
    }

    setSelectedFile(file);
    setError(null);
    onFileUpload(file);
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    setError(null);
    onFileRemove();

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  return (
    <Box textAlign="start">
      <label htmlFor="csv-upload" style={{ cursor: "pointer" }}>
        <img src={uploadCSV} alt="Upload CSV" className="mb-4 w-48 h-auto" />
        <h2 className="text-[blue] underline cursor-pointer">Upload CSV</h2>
      </label>
      <input
        type="file"
        accept=".csv"
        id="csv-upload"
        hidden
        // ref={fileInputRef}
        onChange={handleFileChange}
      />

      {error && <Typography color="error">{error}</Typography>}
      {selectedFile && (
        <Box display="flex" alignItems="center" justifyContent="start">
          <Typography>{selectedFile.name}</Typography>
          <IconButton onClick={handleRemoveFile} size="small" color="error">
            <DeleteIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default CSVUploader;
